import User from "../../icons/b2b-user.svg?react";
import Bags from "../../icons/bags.svg?react";
import AirConditioning from "../../icons/car/airCondition.svg?react";
import Airport from "../../icons/car/airport.svg?react";
import Mileage from "../../icons/car/mileage.svg?react";
import Transmission from "../../icons/car/transmission.svg?react";
import check from "../../icons/check-circle.svg?react";

import { CarIconName, type CarIconSet } from "./types";

export const defaultCarIcons: CarIconSet = {
  [CarIconName.car__airConditioning]: AirConditioning,
  [CarIconName.car__airport]: Airport,
  [CarIconName.car__bags]: Bags,
  [CarIconName.car__passenger]: User,
  [CarIconName.car__rentalAttribute]: check,
  [CarIconName.car__transmission]: Transmission,
  [CarIconName.car__mileage]: Mileage,
};
